import { mapActions } from "../reducer";

export const resetSelectedPoint = () => mapActions.setSelectedPoint();
